/* eslint-disable */
import { Suspense, useEffect } from "react";
import { useStores } from "../use.store";
import React from "react";
import Div100vh from "react-div-100vh";
import { observer } from "mobx-react-lite";

import { useDispatch } from "react-redux";
import { AdsignMap, MapStore } from "@adactiveasia/adsign-map";
import { adsignMapConfiguration, mapOption } from "../utils/constants";

const Splashscreen = observer(() => {
  const { generalStore } = useStores();
  const mapStore = React.useRef(new MapStore()).current;
  const cameraControlsRef = React.useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    if (mapStore.pois && mapStore.pois.length) {
      generalStore.setStepLoading(1);
      generalStore.setAllPoi(mapStore.pois);
      generalStore.setStepLoading(2);
      generalStore.setAllFloors(mapStore.floors);
      generalStore.setCategoryPois(mapStore.categoryPois);
      setTimeout(() => {
        generalStore.setStepLoading(3);
        generalStore.setLoading(false);
      }, 1000);
    }
  }, [mapStore.pois]);

  const renderMap = () => {
    return (
      <Suspense>
        <AdsignMap
          cameraControlsRef={cameraControlsRef}
          config={adsignMapConfiguration}
          store={mapStore}
          onShapeClick={(e) => {}}
          mapOption={mapOption}
        />
      </Suspense>
    );
  };

  return (
    <Div100vh>
      <div className="w-full h-full bg-no-repeat bg-cover bg-bottom bg-splashscreen-bg flex flex-col justify-center items-center overflow-hidden">
        <img
          src={require(`../assets/images/logo.png`)}
          alt=""
          className="w-[200px] h-[60px] bg-no-repeat bg-center bg-contain mb-4"
        />

        <div class="absolute bottom-12 flex items-center justify-center w-full flex-col gap-2">
          <div className="w-2/4 h-[4px] bg-[#FFFFFF] rounded-full">
            <div
              className={`w-[${
                (generalStore.stepLoading / 3) * 100
              }%] h-[4px] bg-[#E09948] rounded-full`}
            ></div>
          </div>
          <div className="w-2/3 flex flex-row items-center justify-center mt-2 text-[8px] gap-1">
            {generalStore.stepLoading < 3 && (
              <span className="text-[#3D3D3D] text-[12px]">
                {Math.ceil((generalStore.stepLoading / 3) * 100)}%
              </span>
            )}
            <span
              className={
                generalStore.stepLoading == 3
                  ? "text-[#3D3D3D] text-[12px]"
                  : "text-[#3D3D3D] text-[12px]"
              }
            >
              {generalStore.stepLoading == 3
                ? "Welcome to Enabling Village"
                : "Preparing your experience"}
            </span>
          </div>
        </div>
      </div>
      {renderMap()}
    </Div100vh>
  );
});

export default Splashscreen;
